import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendGetRequest } from '../../../api/requestUtil';
import { AppState } from '../../../store/store';
import { setUnreadNotificationsCount } from '../slices/notificationsReducer';

const POLLING_INTERVAL = 3600000;

const NotificationsManagerComponent = () => {
  const dispatch = useDispatch();
  const { authToken, isLoggedIn } = useSelector((state: AppState) => {
    return state.user;
  });
  const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const fetchUnreadNotificationsCount = useCallback(async () => {
    if (!authToken || !isLoggedIn) {
      dispatch(setUnreadNotificationsCount(0));
      return;
    }
    try {
      const url = `/api/notifications/?unread_only=true`; // Ensure leading slash for relative paths

      const data: NotificationType[] = await sendGetRequest(url, authToken);

      const unreadCount = data.length;
      dispatch(setUnreadNotificationsCount(unreadCount));
    } catch (err: any) {
      console.error('Error fetching notifications count:', err);
      dispatch(setUnreadNotificationsCount(0));
    }
  }, [authToken, isLoggedIn, dispatch]);

  useEffect(() => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    if (isLoggedIn && authToken) {
      fetchUnreadNotificationsCount();
      pollingIntervalRef.current = setInterval(() => {
        fetchUnreadNotificationsCount();
      }, POLLING_INTERVAL);
    } else {
      dispatch(setUnreadNotificationsCount(0));
    }

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [fetchUnreadNotificationsCount, isLoggedIn, authToken, dispatch]);

  return null;
};

export default NotificationsManagerComponent;
